module.exports = {
	"en": {
		"translation": {
			"moreInformation": "more information",
			"close": "Close",
			"uploader": {
				"overlay": {
					"title": "Drag and drop",
					"subtitle": "Your files here"
				},
				"form": {
					"dragAndDrop": "Drag and drop",
					"or": "or",
					"chooseFiles": "Choose files",
					"from": "From your computer"
				},
				"errors": {
					"file_size": "exceeds the maximum {{size}} file size.",
					"file_type": "{{type}} is incorrect file type."
				},
				"status": {
					"idle": "idle",
					"processing": "processing",
					"uploading": "uploading",
					"success": "success",
					"cancel": "cancel",
					"error": "error",
					"none": ""
				}
			},
			"actions": {
				"delete": "Delete",
				"apply": "Apply",
				"cancel": "Cancel"
			},
			"dateInput": {
				"choose": "Choose a Date",
				"clear": "Clear Date"
			},
			"daterange": {
				"last_7_days": "Last 7 Days",
				"last_30_days": "Last 30 Days",
				"this_month": "This Month",
				"last_month": "Last Month",
				"start_date": "Start Date",
				"end_date": "End Date",
				"not_set": "Not set"
			},
			"comment": {
				"delete": "Delete comment"
			},
			"pagination": {
				"intro": "Pagination, currently on page {{currentPage}}",
				"page": "Page {{pageNumber}}",
				"ellipsis": "More pages",
				"prev": "Previous page",
				"next": "Next page"
			},
			"formElement": {
				"optional": "(optional)",
				"required": "(required)"
			},
			"prevNextArrowButton": {
				"arrowup": "up",
				"arrowdown": "down",
				"escape": "escape"
			},
			"externalLink": {
				"view": "view"
			},
			"collapsible": {
				"ariaText": "collapsible section"
			}
		}
	}
};